export const defaultLayer = 0;
export const screenRaycasterLayer = 1;
export const objectPickerLayer = 2;
export const collisionPersonLayer = 3;
export const pointerRaycasterLayer = 4;
